import { gql } from 'apollo-angular';

export const CREATE_VENDOR = gql`
  mutation createVendor($createVendorInput: CreateVendorInput!) {
    createVendor(createVendorInput: $createVendorInput) {
      id
    }
  }
`;

export const UPDATE_VENDOR = gql`
  mutation updateVendor(
    $updateVendorInput: UpdateVendorInput!
    $id: Int!
  ) {
    updateVendor(
      updateVendorInput: $updateVendorInput
      id: $id
    ) {
      id
    }
  }
`;

export const REMOVE_VENDOR = gql`
  mutation removeVendor($id: Int!) {
    removeVendor(id: $id)
  }
`;
